import React from 'react';
import formatBoolean from '../formatters/formatBoolean';
import formatInteger from '../formatters/formatInteger';
import formatNull from '../formatters/formatNull';
import formatNumber from '../formatters/formatNumber';
import formatString from '../formatters/formatString';
import { STRING, INTEGER, NUMBER, BOOLEAN, NULL } from '../types';
import coerceToFloat from '../utils/coerceToFloat';
import coerceToInteger from '../utils/coerceToInteger';

// Fallback value if formatting ever throws an exception.
export const NO_DATA_DEFAULT = '---';

/**
 * Delegates the formatting of basic data types based on its schema.
 * To format object and array types, use a custom component definition.
 * @param {Object} schema - The schema, this can correspond
 * to the entire schema or a sub schema.
 * @param {*} data - The data corresponding to the schema
 * @returns {Object} data - A combined object containing the data and schema
 */
const formatData = (schema, data = NO_DATA_DEFAULT) => {
  const { type, format } = schema;

  switch (type) {
    case INTEGER:
      return formatInteger(coerceToInteger(data), format);
    case NUMBER:
      return formatNumber(coerceToFloat(data), format);
    case STRING:
      return formatString(data, format);
    case BOOLEAN:
      return formatBoolean(data);
    case NULL:
      return formatNull(data);
    default:
      return <>{data}</>;
  }
};

export default formatData;
